module.exports = __webpack_public_path__ + "static/img/rank_189.c359a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_189.png
// module id = /Qkb
// module chunks = 1